import React, { useState } from "react";
import { X } from "lucide-react";
import { createPanelPoll } from "app/apis/panels";
import { useAppContext } from "app/contexts/AppContext";
import { useTranslation } from "react-i18next";

const NewPoll = () => {
    const { selectedPanel } = useAppContext()
    const [mode, setMode] = useState("edit");
    const [question, setQuestion] = useState("Your poll question here...");
    const [options, setOptions] = useState(["Vote"]); // Only one option now
    const [selectedOption, setSelectedOption] = useState(null);
    const employee_id = sessionStorage.getItem("employee_id");
    const [error, setError] = useState(null);
    const [isPublished, setIsPublished] = useState(false);
    const { t } = useTranslation();
    const handleOptionChange = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    // Remove the addOption function since we don't need it anymore

    const removeOption = (index) => {
        // Don't allow removing the only option
        if (options.length > 1) {
            setOptions(options.filter((_, i) => i !== index));
        }
    };

    const handlePublish = async () => {
        if (question.trim() && options.every((opt) => opt.trim())) {
            const formData = new FormData();
            formData.append("question", question);
            formData.append("panel", selectedPanel?.uu_id);
            formData.append("created_by", employee_id);
            options.forEach((opt, index) => {
                formData.append(`choices[${index}][text]`, opt);
            });

            for (let [key, value] of formData.entries()) {
                console.log(key + ": " + value);
            }
            try {
                const response = await createPanelPoll(formData);
                if (response.status === 201) {
                    setIsPublished(true);
                    setError(null);
                    setMode("view");

                    // Reset the form fields
                    setQuestion("Your poll question here...");
                    setOptions(["Vote"]); // Reset to single option
                    setSelectedOption(null);
                }
            } catch (error) {
                setError(error?.response?.data?.message || "An error occurred while publishing the poll.");
                setIsPublished(false);
                console.log(error);
            }
        } else {
            setError("Please fill out the question and the option before publishing.");
        }
    };

    const closeConfirmation = () => {
        setIsPublished(false);
    };

    const closeError = () => {
        setError(null);
    };

    return (
        <>
            <textarea
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                rows={3}
                maxLength={516}
                className="w-full px-3 py-2 mb-3 text-gray-700 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="grid grid-cols-2 gap-4 mt-4">
                {options.map((option, index) => (
                    <div key={index} className="border p-3 rounded-lg shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    checked={selectedOption === index}
                                    onChange={() => setSelectedOption(index)}
                                    disabled={mode !== "edit"}
                                    className="mr-2"
                                />
                                <input
                                    type="text"
                                    value={option}
                                    disabled
                                    onChange={(e) => handleOptionChange(index, e.target.value)}
                                    className="text-gray-700 font-medium border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            {/* Remove the delete button since we don't want to remove the only option */}
                        </div>
                    </div>
                ))}
            </div>

            {/* Remove the "Add Option" button since we only want one option */}

            <div className="flex justify-between items-center mt-4">
                <button onClick={handlePublish} className="px-4 py-2 text-white bg-[#DCBD7F] rounded-md disabled:bg-gray-300">
                    Publish
                </button>
            </div>

            {/* Confirmation Card */}
            {isPublished && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 20000 }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        {/* <h2 className="text-xl font-semibold mb-4">Poll Published Successfully!</h2> */}
                        <h2 className="text-xl font-semibold mb-4">{t('Poll Published Successfully!')}</h2>
                        {/* <p>Your poll has been published and is now live.</p> */}
                        <p>{t('Your poll has been published and is now live.')}</p>
                        <button
                            onClick={closeConfirmation}
                            className="mt-4 px-4 py-2 bg-[#DCBD7F] text-white rounded-md hover:bg-[#DCBD7F]"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* Error Card */}
            {error && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 20000 }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        {/* <h2 className="text-xl font-semibold mb-4 text-red-500">Error</h2> */}
                        <h2 className="text-xl font-semibold mb-4 text-red-500">{t('Error')}</h2>
                        <p>{error}</p>
                        <button
                            onClick={closeError}
                            className="mt-4 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                        >
                            {/* Close */}
                            {t("Close")}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewPoll;